var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.navigationLength > 0
    ? _c(
        "ul",
        {
          staticClass: "my-courses-navigation",
        },
        _vm._l(_vm.navigation, function (nav, index) {
          return _c(
            "li",
            {
              key: index,
              staticClass: "my-courses-navigation-item",
              class: nav.class,
            },
            [
              nav
                ? _c(
                    "a",
                    _vm._b(
                      {
                        attrs: {
                          href: nav.url,
                        },
                      },
                      "a",
                      nav.attr,
                      false
                    ),
                    [
                      _c("studip-icon", {
                        attrs: {
                          shape: nav.icon.shape,
                          role: nav.icon.role,
                          size: _vm.iconSize,
                        },
                      }),
                    ],
                    1
                  )
                : _c("span", {
                    staticClass: "empty-slot",
                    style: {
                      width: "".concat(_vm.iconSize, "px"),
                    },
                  }),
            ]
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }